import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ListEvent } from '@core/models';
import { DATE_FORMAT } from '@core/constants';
import { EventColumnTypes } from '@core/enums';
import { DatePipe, NgClass } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-event-column',
  templateUrl: './event-column.component.html',
  styleUrls: ['./event-column.component.scss'],
  imports: [DatePipe, NgClass, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventColumnComponent {
  @Input() eventType!: number;
  @Input() event!: ListEvent;
  @Input() isLastVisited: boolean = false;
  public eventColumnTypes = EventColumnTypes;
  public dateFormat = DATE_FORMAT;

  get startMissed(): boolean {
    if (this.eventType !== EventColumnTypes.todays) return false;
    const startTime = new Date(this.event.start_datetime).getTime();
    const currentTime = new Date().getTime();

    return currentTime > startTime && !this.event?.is_started;
  }

  get isLessThanTwoHoursAway(): boolean {
    const targetTime = new Date(this.event.start_datetime).getTime();
    const currentTime = new Date().getTime();
    const diffInMs = targetTime - currentTime;

    const twoHoursInMs = 7200000;

    return diffInMs > 0 && diffInMs < twoHoursInMs;
  }
}
